import {SIZE_MEDIUM} from '../../../common/modal/modal-service';
import refreshTravellerDetailsModal from '../../templates/refresh-traveller-details-modal.html';

export default function RefreshTravellerDetailsService(
    $uibModal,
    $q,
    $http,
) {
    'ngInject';

    Object.assign(this, {
        showRefreshTravellerDetailsPopup,
        checkTravellerDetailsChanges,
        updateTravellersByProfile,
    });

    function checkTravellerDetailsChanges(travellers) {
        const adults = travellers.filter((traveller) => !!traveller.TravellerProfileId
            && !traveller.RelevantToProfile);

        // TODO: disabled temporary because of APS-1753, APS-1920
        if (false && adults.length) { //eslint-disable-line
           return showRefreshTravellerDetailsPopup(adults)
               .result
               .then(updateTravellersByProfile);
        }
        return $q.reject();
    }

    function showRefreshTravellerDetailsPopup(travellers) {
        return $uibModal.open({
            template: refreshTravellerDetailsModal,
            size: SIZE_MEDIUM,
            controllerAs: 'modalCtrl',
            controller: function() {
                this.travelers = travellers;
            },
        });
    }

    function updateTravellersByProfile(travellerRequestData) {
        return $http.apiPOST('/trips/updateTravellersByProfile', travellerRequestData);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/refresh-traveller-details-popup/refresh-traveller-details-service.js